export const GROWTH = [
    {
        country: "Argentina",
        keywords: [],
        price: 0.121
    },
    {
        country: "Brazil",
        keywords: [],
        price: 0.122
    },
    {
        country: "Chile",
        keywords: [],
        price: 0.155
    },
    {
        country: "Colombia",
        keywords: [],
        price: 0.059
    },
    {
        country: "Egypt",
        keywords: [],
        price: 0.178
    },
    {
        country: "France",
        keywords: [],
        price: 0.223
    },
    {
        country: "Germany",
        keywords: [],
        price: 0.214
    },
    {
        country: "India",
        keywords: [],
        price: 0.057
    },
    {
        country: "Indonesia",
        keywords: [],
        price: 0.095
    },
    {
        country: "Israel",
        keywords: [],
        price: 0.088
    },
    {
        country: "Italy",
        keywords: [],
        price: 0.13
    },
    {
        country: "Malaysia",
        keywords: [],
        price: 0.151
    },
    {
        country: "Mexico",
        keywords: [],
        price: 0.098
    },
    {
        country: "Netherlands",
        keywords: [],
        price: 0.243
    },
    {
        country: "Nigeria",
        keywords: [],
        price: 0.108
    },
    {
        country: "Pakistan",
        keywords: [],
        price: 0.103
    },
    {
        country: "Peru",
        keywords: [],
        price: 0.132
    },
    {
        country: "Russia",
        keywords: [],
        price: 0.144
    },
    {
        country: "Saudi Arabia",
        keywords: [],
        price: 0.101
    },
    {
        country: "South Africa",
        keywords: [],
        price: 0.091
    },
    {
        country: "Spain",
        keywords: [],
        price: 0.121
    },
    {
        country: "Turkey",
        keywords: [],
        price: 0.057
    },
    {
        country: "United Arab Emirates",
        keywords: [],
        price: 0.092
    },
    {
        country: "United Kingdom",
        keywords: [
           "ngland",
            "northern ireland",
            "scotland",
            "wales"
        ],
        "price": 0.11
    },
    {
        country: "North America",
        keywords: [
           "nited states, usa, canada"
        ],
        "price": 0.075
    },
    {
        country: "Rest of Africa",
        keywords: [],
        price: 0.072
    },
    {
        country: "Rest of Asia Pacific",
        keywords: [],
        price: 0.135
    },
    {
        country: "Rest of Central & Eastern Europe",
        keywords: [],
        price: 0.151
    },
    {
        country: "Rest of Latin America",
        keywords: [],
        price: 0.136
    },
    {
        country: "Rest of Middle East",
        keywords: [],
        price: 0.086
    },
    {
        country: "Rest of Western Europe",
        keywords: [],
        price: 0.118
    },
    {
        country: "Other",
        keywords: [],
        price: 0.119
    }
];